import PropTypes from 'prop-types';
import React from 'react';
import { polyfill } from 'react-lifecycles-compat';
import withRouter from './with-router';

class Garden extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      history: props.history,
      Component: null,
    };

    this.block = this.block.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    history.block(this.block);

    this.block(location); // init.
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.skipDerived) {
      return {
        skipDerived: false,
      };
    }
    return {
      Component: nextProps.watcher(prevState.history.location, false),
      fromLocationChange: false,
    };
  }

  block(location) {
    const { watcher } = this.props;

    const result = watcher(location, true);

    this.setState({
      Component: result,
      skipDerived: true,
      fromLocationChange: true,
    });

    return typeof result === 'function' ? false : result;
  }

  render() {
    const { children } = this.props;
    const { Component, fromLocationChange } = this.state;

    if (typeof Component === 'function') {
      return <Component />;
    }

    if (!fromLocationChange && Component === false) {
      return null;
    }
    return children;
  }
}

if (process.env.NODE_ENV !== 'production') {
  Garden.propTypes = {
    value: PropTypes.shape({}),
    location: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      block: PropTypes.func.isRequired,
    }).isRequired,
    watcher: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired,
  };
}

export default withRouter(polyfill(Garden));
